import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

import { checkEnvironment } from '../../helpers/access/checkEnvironment'

export const useEnvironmentCheck = () => {
  const ownerId = useSelector(selectAppOwnerId)

  return useMemo(() => {
    return checkEnvironment(ownerId)
  }, [ownerId])
}
